import { Theme } from 'framework/theme/types';
import { SYSTEM_COLORS } from '../constants';
import { getThemedColor } from './getThemedColor';

// The system colors as the stylesheets' CSS variables, for each theme, so that whatever is styled
// with them follows the theme it is in. Set once, at the start.
export function installSystemColors() {
	const style = document.createElement('style');
	style.textContent = [
		`:root, [data-theme='light'] {${getDeclarations(Theme.Light)}}`,
		`[data-theme='dark'] {${getDeclarations(Theme.Dark)}}`,
	].join('\n');

	document.head.appendChild(style);
}

function getDeclarations(theme: Theme) {
	return Object.values(SYSTEM_COLORS)
		.flatMap((color) => {
			const declarations = [`${color.cssVar}: ${getThemedColor(color, theme)};`];
			if (color.shades) {
				declarations.push(
					`${color.cssVar}-lighter: hsl(from var(${color.cssVar}) h s calc(l + 10));`,
					`${color.cssVar}-darker: hsl(from var(${color.cssVar}) h s calc(l - 10));`,
				);
			}
			return declarations;
		})
		.join('');
}
